import { render, staticRenderFns } from "./ProductRequestSummary.vue?vue&type=template&id=512e6ba9&"
import script from "./ProductRequestSummary.vue?vue&type=script&lang=js&"
export * from "./ProductRequestSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports